import styled, { css } from 'styled-components';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';

const modalType = (type, bigModal) => {
  if (type === 'close') {
    return css`
      font-size: 16px;

      margin: 0;
      line-height: 28px;
    `;
  }
  if (type === 'closeRetailer') {
    return css`
      font-size: 16px;
      max-width: 452px;
    `;
  }
  if (type === 'mergerEditPopup') {
    return css`
      font-size: 16px;
    `;
  }
  if (type === 'closeFreeTextFields') {
    return css`
      font-size: 16px;
      max-width: 500px;

      @media ${DEVICES.tablet} {
        width: 100%;
        margin: 0 20px;
      }
    `;
  }
  if (type === 'popupMap') {
    return css`
      font-size: 16px;
      max-width: 476px;
    `;
  }
  if (type === 'popupAgencies') {
    return css`
      display: block;
      max-width: 476px;
      @media ${DEVICES.tablet} {
        height: 100vh;
        width: 100vw;
        display: block;
      }
    `;
  }
  if (type === 'closeModalEndEdit' && !bigModal) {
    return css`
      font-size: 16px;
      width: 450px;
      font-weight: 400;
      color: #0d0d0d;
      @media ${DEVICES.tablet} {
        width: 100%;
      }
    `;
  }
  if (type === 'closeModalEndEdit' && bigModal) {
    return css`
      font-size: 16px;
      width: 700px;
      font-weight: 400;
      color: ${UiColors.blackFillColor};
    `;
  }
  if (type === 'agenciesInfo') {
    return css`
      color: ${UiColors.dimGreyFillColor};
      margin-bottom: 29px;
      font-size: 16px;
    `;
  }

  if (type === 'closeModalAttention') {
    return css`
      font-size: 16px;
      max-width: 340px;
      color: #737373 !important;
    `;
  }
  if (type === 'PII') {
    return css`
      font-size: 14px;
      max-width: 588px;
      @media ${DEVICES.mobileL} {
        padding-bottom: 25px;
      }
    `;
  }
  if (type === 'mergerHistoric' && !bigModal) {
    return css`
      font-size: 16px;
      width: 450px;
      font-weight: 800;
      color: #0d0d0d;
      @media ${DEVICES.tablet} {
        width: 100%;
        overflow: scroll;
      }
      @media ${DEVICES.mobileL} {
        height: 290px;
      }
    `;
  }
  return css`
    font-size: 16px;
    max-width: 432px;
  `;
};

const ContentModal = styled.section.attrs(() => ({ ariaRequired: true }))`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
  width: 100%;
  margin: 5px 0 15px 0;

  ${(props) => modalType(props.type, props.bigModal)};

  ${({ containModal }) =>
    containModal === 'mergerHistoric' &&
    css`
      @media ${DEVICES.tablet} {
        width: 100%;
        height: 270px;
      }
      @media ${DEVICES.mobileM} {
        width: 100%;
        height: 310px;
      }
    `}

  ${({ containModal }) =>
    containModal === 'mergerDuplicate' &&
    css`
      @media ${DEVICES.tablet} {
        height: 300px;
      }
      @media ${DEVICES.mobileM} {
        height: 350px;
      }
    `}
`;

const ModalMessage = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;

  ${({ type }) => modalType(type)};

  @media ${DEVICES.mobileL} {
    line-height: ${({ type }) => (type === 'PII' ? '24px' : '21px')};
    font-size: ${({ type }) => (type === 'PII' ? '18px' : '14px')};
  }
`;

export { ContentModal, ModalMessage };
